import { useState } from "react";
import { getUsersInGroup } from "../../service/GroupService";


export const useGroupUsers = (id) => {
  const [userList, setUserList] = useState([]);
  const [error, setError] = useState(null);

  const fetchUsers = async (page = 0, size = 10, search) => {
    const result = await getUsersInGroup(id, page, size, search);
    if (result?.success) {
      const data = result.data;

      if (!data?.content) {
        console.error("Invalid response received:", data);
        setUserList([]);
        return null;
      }

      const users = data.content.map((user, index) => ({
        id: user.userId,
        userName: user.userName,
        name: `${user.firstName} ${user.lastName}`,
        email: user.email,
        progress: user.progress,
        enrols: user.enrols,
        srno: page * size + (index + 1),
      }));

      setUserList(users);
      setError(null);
      return data; 
    } else {
      console.error("Error fetching users in group:", result?.data);
      setUserList([]);
      setError(result?.data);
      return null;
    }
  };

  return {
    userList,
    error,
    fetchUsers,
  };
};